import React, { useReducer } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';

import './App.scss';
import { AnimatedSwitch } from 'react-router-transition';

import Input from 'components/pages/Input';
import Conf from 'components/pages/Conf';
import Thanks from 'components/pages/Thanks';
import AddJobDescription from 'components/pages/AddJobDescription';
import AddSkill from 'components/pages/AddSkill';
import AddCondition from 'components/pages/AddCondition';
import AddEnvi from 'components/pages/AddEnvi';
import AddInfo from 'components/pages/AddInfo';
import AddConf from 'components/pages/AddConf';
import AddThanks from 'components/pages/AddThanks';

import {
  INPUT_URL,
  CONF_URL,
  THANKS_URL,
  ADD_JOB_DESCRIPTION_URL,
  ADD_SKILL_URL,
  ADD_CONDITION_URL,
  ADD_ENVI_URL,
  ADD_INFO_URL,
  ADD_CONF_URL,
  ADD_THANKS_URL,
  FIRST_URL,
  debugInitialState,
} from 'utils/constant';

import AppContext from 'fluxes/context';
import AppReducer from 'fluxes/reducer';

const App = () => {

  const initialState = {
    /* Input or Add-Info */
    workCategory: '',
    workCategoryOtherDetail: '',
    workDetailText: '',
    receiptID: '',
    clickID: '',
    mediaID: '',

    /* Input or Add-Info */
    companyNameText: '',
    dept: '',
    chargePersonNameText: '',
    tel: '',
    email: '',
    address: '',
    employmentPlacementDispatching: false,

    /* Add-Input*/
    howToDo: '01',
    bgdOfRecruitment: '',
    bgdOfRecruitmentCmnt: '',
    desiredStartDateKubun: '',
    desiredStartDate: '',
    workPeriod: '',
    workPeriodDate: '',

    /* Input or Add-Condition */
    ekiCd: '',
    ekiName: '',

    /* Add-JobDescription */
    duty: [],
    dutyCmnt: '',
    workInfoContent: [],
    workInfoContentCmnt: '',
    apiSkillList:[],

    /* Add-Skill */
    excelSkill: [],
    otherSkills: [],
    skillOtherCmnt: '',

    /* Add-Condition */
    startTime: [ '', '' ],
    endTime: [ '', '' ],
    startTimeRangeStart: [ '', '' ],
    startTimeRangeEnd: [ '', '' ],
    endTimeRangeStart: [ '', '' ],
    endTimeRangeEnd: [ '', '' ],
    overTimeRange: [ '', '' ],
    workingDayRange: [ '', '' ],
    workingDayRangeOthers: false,
    workingDayCmnt: '',
    attendance: [],
    remoteWorkCount: '',
    hourSalaryMin: 0,
    hourSalaryMax: 0,

    /* Add-Envi */
    welfare: [],
    welfareCmnt: '',
    workEnvi: [],
    ageRange: [ '', '' ],
    genderRange: '',
    workEnviCmnt: '',

    otherComment: '',

    isModify: false,
    validMap: {
      [INPUT_URL]: false,
      [CONF_URL]: false,
      [THANKS_URL]: false,
      [ADD_JOB_DESCRIPTION_URL]: false,
      [ADD_SKILL_URL]: false,
      [ADD_CONDITION_URL]: false,
      [ADD_ENVI_URL]: false,
      [ADD_INFO_URL]: false,
      [ADD_CONF_URL]: false,
      [ADD_THANKS_URL]: false,
    },
    isRegistered: false,
    isAddRegistered: false,
  };
  
  // const [ state, dispatch ] = useReducer(AppReducer, debugInitialState);
  const [ state, dispatch ] = useReducer(AppReducer, initialState);

  const NotFound = () => <Redirect to={FIRST_URL} />;

  const routes = [
    { path: INPUT_URL, Component: Input },
    { path: CONF_URL, Component: Conf },
    { path: THANKS_URL, Component: Thanks },
    { path: ADD_JOB_DESCRIPTION_URL, Component: AddJobDescription },
    { path: ADD_SKILL_URL, Component: AddSkill },
    { path: ADD_CONDITION_URL, Component: AddCondition },
    { path: ADD_ENVI_URL, Component: AddEnvi },
    { path: ADD_INFO_URL, Component: AddInfo },
    { path: ADD_CONF_URL, Component: AddConf },
    { path: ADD_THANKS_URL, Component: AddThanks },
  ];

  const transStyle = {
    atEnter: { right: 0, opacity: 0.5 },
    atLeave: { right: 1000, opacity: 0 },
    atActive: { right: 0, opacity: 1 },
  };
  return (
    <div className="App">
      <AppContext.Provider value={{ state, dispatch }}>
        <Router>
          <AnimatedSwitch
            atEnter={transStyle.atEnter}
            atLeave={transStyle.atLeave}
            atActive={transStyle.atActive}
            className="App-switch-wrapper"
          >
            {routes.map(({ path, Component }) => (
              <Route exact key={path} path={path} component={Component} />
            ))}
            <Route path='/' component={NotFound} />
          </AnimatedSwitch>
        </Router>
      </AppContext.Provider>
    </div>
  );
};

export default App;
